import script from "./CustomListDocMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListDocMenu.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListDocMenu.vue?vue&type=style&index=0&id=1bc64299&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc64299"]])

export default __exports__